<template>
   <div>
       <b-row no-gutters class="mx-0 border-bottom border-color-gray-300 pb-1 mb-2 gray-550">
           <b-col class="col-9 f-90"> 평가기준</b-col>
           <b-col class="col-2 text-center f-90"> 점수</b-col>
           <b-col class="col-1 text-center f-90"> 초기화</b-col>
       </b-row>
       <b-row v-for="(item, index) in ev_scoring_list" :key="`subs-${sub_code}-ev-${item.ev_id}`"
              no-gutters
              :class="['d-flex justify-content-bewteen align-items-center mx-0 mb-3', { 'bg-blue2': item.is_audited }]"
       >
           <b-col class="col-9" style="margin-top: 12px">
               <b-form-checkbox v-model="item.manual_satisfied"
                                class="f-95"
                                style="margin-left: 12px"
                                :disabled="item.manual_not_applicable || is_not_applicable === null || is_updating_ev_scoring || disabled"
                                @change="toggleManualSatisfied"
               >
                   {{ item.ev_name }}
               </b-form-checkbox>
           </b-col>
           <b-col cols="2" :class="[{ 'red5 f-90': item.manual_not_applicable }, 'text-center']">
                        <span :class="[{ 'gray-550': is_updating_ev_scoring || disabled }]">
                            {{ item.manual_not_applicable ? `해당없음` : item.score ?? 0 }}
                        </span>
           </b-col>
           <b-col class="col-1 text-center">
               <b-button class="py-1" :variant="item.author_id !== null ? 'icon-blue' : 'icon-dark'"
                         :disabled="item.manual_not_applicable || is_not_applicable === null || is_updating_ev_scoring || !item.is_audited || disabled"
                         @click="resetEvaluation(index)"
               >
                   <fa icon="history"></fa>
               </b-button>
           </b-col>
           <b-col class="col-12 d-flex" style="margin-bottom: 12px">
               <template v-if="item.is_audited">
                   <fa icon="comment-dots" class="ml-3 mr-2 mt-4 blue7"></fa>
               </template>
               <template v-else>
                   <div class="ml-3 mr-2" style="width: 15px"></div>
               </template>
               <div class="audit-container">
                   <b-form-select 
                       v-model="item.audit_category_code"
                       class="audit-category"
                       :disabled="is_updating_ev_scoring || is_not_applicable === null || disabled"
                       @change="handleChange"
                   >
                       <b-form-select-option v-for="category in audit_category"
                                             :key="category.code"
                                             :value="category.code"
                                             :disabled="category.code == null"
                       >
                           {{ get_audit_category_name(category) }}
                       </b-form-select-option>
                   </b-form-select>
                   <b-form-textarea
                       v-model="item.audit_comment"
                       placeholder="평가 항목별 의견"
                       :class="[{ 'blue7 italic': item.is_audited },'f-95 audit-comment']"
                       :disabled="is_updating_ev_scoring || is_not_applicable === null || disabled"
                       :rows="6"
                       :max-rows="6"
                       @blur="handleChange"
                   >
                   </b-form-textarea>
               </div>
           </b-col>
       </b-row>
   </div>
</template>

<script>
import {debounce} from 'lodash';
import {mapState} from 'vuex';

export default {
    name: 'UserEvaluationComponent',
    props: {
        sub_code: {
            type: String
        },
        ev_scoring_list: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        is_updating_ev_scoring: {
            type: Boolean,
            default: false
        },
        is_not_applicable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapState('evaluations', ['audit_category']),
        get_audit_category_name(){
            return (item) => {
                if (this.$i18n.locale === 'ko')
                    return item.category;
                if(this.$i18n.locale === 'en') 
                    return item.category_ea;
                if(this.$i18n.locale === 'ca') 
                    return item.category_ca;
                return item.category;
            }; 
        },
    },
    methods: {
        toggleManualSatisfied: debounce(async function () {
            this.$emit('handleChange', this.sub_code);
        }, 2500), // 4500
        async handleChange() {
            this.$emit('handleChange', this.sub_code);
        },
        async resetEvaluation(i) {
            this.$emit('resetEvaluation', i);
        },
    }
};
</script>

<style lang="scss" scoped>
.audit-desc {
    width: 100%;
    font-size: 0.95rem;
    color: #6c757d;
    margin-bottom: 5px;
}
.audit-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
    margin-top: 10px;
    margin-right: 12px;

    .audit-category {
    }

    .audit-comment {
        resize: none;
    }
}
</style>
